import { PlayCircle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DemoVideoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DemoVideoDialog({ open, onOpenChange }: DemoVideoDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden">
        <DialogHeader className="p-4 pb-0">
          <DialogTitle className="text-xl">See Aiveliq360 in Action</DialogTitle>
        </DialogHeader>
        <div className="p-4">
          <div className="aspect-video bg-muted rounded-lg flex items-center justify-center relative overflow-hidden">
            {/* Animated background */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-purple-500/10" />
            <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-primary/20 rounded-full blur-3xl animate-pulse" />
            <div className="absolute bottom-1/4 right-1/4 w-32 h-32 bg-purple-500/20 rounded-full blur-3xl animate-pulse delay-700" />
            
            {/* Content */}
            <div className="relative text-center z-10">
              <div className="p-4 rounded-full bg-primary/20 mb-4 inline-block ai-glow">
                <PlayCircle className="h-12 w-12 text-primary" />
              </div>
              <h3 className="text-lg font-semibold mb-1">Demo Video Coming Soon</h3>
              <p className="text-muted-foreground text-sm max-w-sm mx-auto">
                We're preparing an interactive demo that showcases how Aiveliq360 
                transforms your sales process with AI-powered intelligence.
              </p>
            </div>
          </div>

          {/* Feature highlights */}
          <div className="grid grid-cols-3 gap-3 mt-4">
            <div className="p-3 rounded-lg bg-muted/50 text-center">
              <p className="text-xl font-bold text-primary mb-0.5">2 min</p>
              <p className="text-xs text-muted-foreground">Quick overview</p>
            </div>
            <div className="p-3 rounded-lg bg-muted/50 text-center">
              <p className="text-xl font-bold text-primary mb-0.5">7 steps</p>
              <p className="text-xs text-muted-foreground">Complete workflow</p>
            </div>
            <div className="p-3 rounded-lg bg-muted/50 text-center">
              <p className="text-xl font-bold text-primary mb-0.5">AI-first</p>
              <p className="text-xs text-muted-foreground">Sales engine</p>
            </div>
          </div>

          {/* CTA */}
          <div className="flex justify-center gap-3 mt-4">
            <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
              Close
            </Button>
            <Button size="sm" className="ai-glow" onClick={() => onOpenChange(false)}>
              Get Started Instead
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
